import type { UseFieldArrayReturn } from 'react-hook-form';

import { formatMoney } from '~shared/lib/format-money';
import { Clickable } from '~shared/ui/clickable';

import { Int24Close } from '@breeze-platform-ui/iconsPack';

import type { OrderFormValues } from '../order-form';

export const OrderItems = ({
  fields,
  remove,
}: UseFieldArrayReturn<OrderFormValues, 'items'>) => {
  return (
    <>
      {fields.map((field, index) => (
        <div
          key={field.id}
          className={`
            mb-5 box-border flex w-full items-center justify-between gap-4
            rounded-2xl border border-solid border-[#EAECEE] px-4 py-[18px]
            font-body text-base
          `}
        >
          <div
            className={`
              w-full max-w-[278px] overflow-hidden text-ellipsis
              whitespace-nowrap
            `}
          >
            {field.name}&nbsp;{field.isUsed && '(Used)'}
          </div>
          <span className="w-full">
            {field.quantity}&nbsp;×&nbsp;{formatMoney(field.price)}
          </span>
          <div className="w-min">
            <Clickable onClick={() => remove(index)}>
              <Int24Close
                theme={{
                  color: 'rgb(224, 31, 25)',
                  background: 'transparent',
                }}
              />
            </Clickable>
          </div>
        </div>
      ))}
    </>
  );
};
